// Geteilter Zeitraum-Filter (Spec Welle 1, "Einheits-Filter"): ersetzt die bisherigen
// Insel-Selects in Overview.tsx und ArticleAnalysis.tsx. Look identisch zum bisherigen
// Inline-Select (text-xs rounded border), damit kein visueller Bruch entsteht.
import { DASH_RANGES, type DashRange } from "@/api/dashboard";
import { DASH_RANGE_LABELS } from "@/lib/dash-format";

export function RangeFilter({
  value,
  onChange,
  label,
}: {
  value: DashRange;
  onChange: (r: DashRange) => void;
  label: string;
}) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as DashRange)}
      className="text-xs rounded border border-line bg-background text-ink px-2 py-1"
      aria-label={label}
    >
      {DASH_RANGES.map((r) => (
        <option key={r} value={r}>
          {DASH_RANGE_LABELS[r]}
        </option>
      ))}
    </select>
  );
}
